import type {
  IControlSettingData,
  IDynamicControlSetting,
} from '~/presentation/reports/common/type';

import { EReportControlId, IRMetricKey } from '~/presentation/reports/common/type';
import { DEFAULT_FILTER_PRESET } from './default-filter';
import { DEFAULT_UI_PRESET } from './default-ui';
import { getMetricSettingUIs } from '../utils';

const LIST_METRIC = [
  IRMetricKey.ADDED_TO_CART,
  IRMetricKey.ADD_TO_CART_RATE,
  IRMetricKey.CART_ADDITION,
  IRMetricKey.SESSION,
];

export const ADD_TO_CART_PRESET: IControlSettingData = {
  [EReportControlId.METRICS_FILTER]: {
    value: LIST_METRIC,
  },
  [EReportControlId.METRIC]: {
    value: LIST_METRIC[0],
  },
  ...DEFAULT_FILTER_PRESET,
};

export const ADD_TO_CART_UI_PRESET: IDynamicControlSetting = {
  ...DEFAULT_UI_PRESET,
  [EReportControlId.METRICS_FILTER]: getMetricSettingUIs(LIST_METRIC),
};
